import api from './api';

export type OrderStatus = 'pending' | 'confirmed' | 'preparing' | 'shipped' | 'delivered' | 'cancelled';

export interface OrderItem {
  id: number;
  product_id?: number | null;
  product_name: string;
  unit_price: number;
  quantity: number;
  subtotal: number;
}

export interface Order {
  id: number;
  tenant_id: number;
  order_number: string;
  customer_name: string;
  customer_phone: string;
  customer_address?: string | null;
  payment_method: string;
  delivery_method?: string; // 'delivery' (envío a domicilio) | 'pickup' (retiro en tienda)
  notes?: string | null;
  status: OrderStatus;
  total: number;
  created_at: string;
  items: OrderItem[];
}

export const ordersService = {
  async list(status?: string): Promise<Order[]> {
    const { data } = await api.get<Order[]>('/orders', { params: status ? { status } : undefined });
    return data;
  },
  async get(id: number): Promise<Order> {
    const { data } = await api.get<Order>(`/orders/${id}`);
    return data;
  },
  async updateStatus(id: number, status: OrderStatus): Promise<Order> {
    const { data } = await api.patch<Order>(`/orders/${id}/status`, { status });
    return data;
  },
};
